import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Dropdown } from '../../components/Dropdown/Dropdown';

class AdvancedSort extends Component {
  static propTypes = {
    isDisplayAdvancedSortDialog: PropTypes.bool,
    sortBy: PropTypes.object,
    sortByOrder: PropTypes.object,
    then: PropTypes.object,
    thenOrder: PropTypes.object,
    end: PropTypes.object,
    endOrder: PropTypes.object,
    handleClickAdvancedButton: PropTypes.func,
    handleApplyAdvancedSort: PropTypes.func,
    onSelectChange: PropTypes.func,
    sortBySelectList: PropTypes.array,
    thenSelectList: PropTypes.array,
    endSelectList: PropTypes.array,
    orderSelectList: PropTypes.array
  };

  toolTip() {
    return (
      <Tooltip className='in tooltip-siteone' id='tooltip-advanced-sort'>
        <span>Advanced sort</span>
      </Tooltip>
    );
  }

  render() {
    const {
      isDisplayAdvancedSortDialog,
      sortBy,
      sortByOrder,
      then,
      thenOrder,
      end,
      endOrder,

      handleClickAdvancedButton,
      handleApplyAdvancedSort,
      onSelectChange,

      sortBySelectList,
      thenSelectList,
      endSelectList,
      orderSelectList
    } = this.props;
    return (
      <span className='lot-advanced-sort-btn'>
        <OverlayTrigger placement='bottom' overlay={this.toolTip()}>
          <span
            className='lot-table-advanced-btn'
            onClick={handleClickAdvancedButton}
            style={
              isDisplayAdvancedSortDialog ? { backgroundColor: '#ebecf0' } : {}
            }
          >
            <button type='button' className='lot-sort-img icon-sort-ic' />
          </span>
        </OverlayTrigger>
        {isDisplayAdvancedSortDialog && (
          <React.Fragment>
            <div className='lot-advanced-sort-fade' />
            <div className='lot-advanced-sort-dialog'>
              <span
                className='lot-advanced-close'
                onClick={handleClickAdvancedButton}
              >
                <i className='fa fa-close' />
              </span>
              <div
                style={{ fontWeight: 500, marginBottom: 15, marginTop: -18 }}
              >
                Advanced sort
              </div>
              <div className='sort-block'>
                <div className='sort-label'>Sort by:</div>
                <div className='sort-select-block'>
                  <div className='sort-select-field'>
                    <Dropdown
                      onChange={ref => {
                        onSelectChange(ref, 'sortBy');
                      }}
                      className='filestring-dropdown filter-dropdown'
                      options={sortBySelectList}
                      optionLabel='text'
                      value={sortBy}
                      name='sortBy'
                      placeholder='-- Please select'
                      style={{ width: '100%' }}
                    />
                  </div>
                  <div className='sort-select-order'>
                    <Dropdown
                      onChange={ref => {
                        onSelectChange(ref, 'sortByOrder');
                      }}
                      className='filestring-dropdown filter-dropdown'
                      options={orderSelectList}
                      optionLabel='text'
                      value={sortByOrder}
                      name='sortByOrder'
                      placeholder='-- Please select'
                      style={{ width: '100%' }}
                    />
                  </div>
                </div>
              </div>
              <div className='sort-block'>
                <div className='sort-label'>Then:</div>
                <div className='sort-select-block'>
                  <div className='sort-select-field'>
                    <Dropdown
                      onChange={ref => {
                        onSelectChange(ref, 'then');
                      }}
                      className='filestring-dropdown filter-dropdown'
                      options={thenSelectList}
                      optionLabel='text'
                      value={then}
                      name='then'
                      placeholder='-- Please select'
                      style={{ width: '100%' }}
                    />
                  </div>
                  <div className='sort-select-order'>
                    <Dropdown
                      onChange={ref => {
                        onSelectChange(ref, 'thenOrder');
                      }}
                      className='filestring-dropdown filter-dropdown'
                      options={orderSelectList}
                      optionLabel='text'
                      value={thenOrder}
                      name='thenOrder'
                      placeholder='-- Please select'
                      style={{ width: '100%' }}
                    />
                  </div>
                </div>
              </div>
              <div className='sort-block'>
                <div className='sort-label'>Then:</div>
                <div className='sort-select-block'>
                  <div className='sort-select-field'>
                    <Dropdown
                      onChange={ref => {
                        onSelectChange(ref, 'end');
                      }}
                      className='filestring-dropdown filter-dropdown'
                      options={endSelectList}
                      optionLabel='text'
                      value={end}
                      name='end'
                      placeholder='-- Please select'
                      style={{ width: '100%' }}
                    />
                  </div>
                  <div className='sort-select-order'>
                    <Dropdown
                      onChange={ref => {
                        onSelectChange(ref, 'endOrder');
                      }}
                      className='filestring-dropdown filter-dropdown'
                      options={orderSelectList}
                      optionLabel='text'
                      value={endOrder}
                      name='endOrder'
                      placeholder='-- Please select'
                      style={{ width: '100%' }}
                    />
                  </div>
                </div>
              </div>
              <div style={{ textAlign: 'left', marginTop: 10 }}>
                <button
                  className='btn btn-siteone'
                  onClick={handleApplyAdvancedSort}
                  disabled={!then}
                >
                  Apply
                </button>
              </div>
            </div>
          </React.Fragment>
        )}
      </span>
    );
  }
}

export default AdvancedSort;



// WEBPACK FOOTER //
// ./src/Lots/Components/AdvancedSort.js